export { default as placeholderImage } from './placeholder.png'
export { default as tolimaImage } from './tolima-region.png'
export { default as loginCardRiceImage } from './login-card-rice.png'
export { default as satelliteImage } from './satellite-image.png'
export { default as logoLuckerImage } from './logo-lucker.png'
